<template>
  <div>
    <!--First-->
    <div id="appNavbar">
      <v-navigation-drawer v-model="sideNav" fixed temporary>
        <v-list-item-content class="hidden-md-and-up">
          <v-list dense>
            <v-list-item v-for="item in guNav" :key="item.name" link>
              <v-list-item-icon>
                <v-icon style="color:#1fb07c;">{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <router-link :to="item.route">
                  <v-list-item-title style="color:#1fb07c;">{{ item.name }}</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-content>
      </v-navigation-drawer>
      <v-toolbar color="#f6782a" dark height="32px" elevation="0">
        <v-app-bar-nav-icon @click.native="sideNav = !sideNav" class="hidden-md-and-up"></v-app-bar-nav-icon>
        <v-toolbar-title pl-12>
          <v-list-item-icon>
            <v-icon style="color:white; font-size:16px;">mdi-twitter</v-icon>
          </v-list-item-icon>
        </v-toolbar-title>
        <v-toolbar-title pl-12>
          <v-list-item-icon>
            <v-icon style="color:white;font-size:16px;">mdi-instagram</v-icon>
          </v-list-item-icon>
        </v-toolbar-title>
        <v-toolbar-title pl-12>
          <v-list-item-icon>
            <v-icon style="color:white;font-size:16px;">mdi-facebook</v-icon>
          </v-list-item-icon>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-toolbar-items class="nav_item hidden-sm-and-down" color="#ff4e00">
          <!-- <v-row justify="center"> -->
          <v-toolbar-title pl-12>
            <router-link to="/Login">
              <h6 class="nav_item AppHeading1" color="white" style="font-size:10px;">DELIVERY</h6>
            </router-link>
          </v-toolbar-title>

          <router-link to="/Login">
            <h6 class="nav_item AppHeading1" color="white" style="font-size:10px;">HELP</h6>
          </router-link>

          <router-link to="/Login"></router-link>
          <span>
            <h6 text class="nav_item AppHeading1" color="white" style="font-size:10px;">
              USD
              <v-icon style="color:white;font-size:13px;">fas fa-caret-down</v-icon>
            </h6>
          </span>

          <router-link to="/Login">
            <h6 class="nav_item AppHeading1" color="white" style="font-size:10px;">
              LANGUAGE
              <v-icon style="color:white;font-size:13px;">fas fa-caret-down</v-icon>
            </h6>
          </router-link>

          <v-spacer></v-spacer>
          <!-- </v-row> -->
        </v-toolbar-items>
      </v-toolbar>
    </div>
    <!--First-End-->
    <div id="appNavbar">
      <v-navigation-drawer v-model="sideNav2" fixed temporary>
        <v-list-item-content class="hidden-md-and-up">
          <v-list dense>
            <v-list-item v-for="item1 in guestNav1" :key="item1.name" link>
              <v-list-item-icon>
                <v-icon style="color:#1fb07c;">{{item1.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <router-link :to="item1.route">
                  <v-list-item-title style="color:#1fb07c;">{{ item1.name }}</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-content>
      </v-navigation-drawer>
      <v-toolbar color="#f6782a" dark height="50px" elevation="0">
        <v-app-bar-nav-icon @click.native="sideNav2= !sideNav2" class="hidden-md-and-up"></v-app-bar-nav-icon>

        <v-toolbar-title pl-12>
          <router-link to="/">
            <span class="AppHeading AppInguz" style="font-size:23px;">INGUZ</span>
          </router-link>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <div v-if="!isLoggedIn">
          <v-toolbar-item class="hidden-sm-and-down">
            <v-toolbar-title pl-12>
              <router-link to="/AppLogin">
                <span
                  class="nav_item AppHeading1 AppInguz tcolor"
                  style="font-size:14px;background-color:white;padding-top:30px;padding-bottom:30px;padding-right:20px;padding-left:20px; "
                >LOGIN</span>
              </router-link>

              <router-link to="/SignUpCommon">
                <span
                  class="nav_item AppHeading1 AppInguz tcolor"
                  style="font-size:14px;background-color:white;padding-top:30px;padding-bottom:30px;padding-right:20px;padding-left:20px; "
                >SIGNUP</span>
              </router-link>
            </v-toolbar-title>

            <!-- <router-link to="/AppLogin">
              <h5 text class="nav_item AppHeading1 AppInguz" >LOGIN</h5>
            </router-link>
            </v-toolbar-title>
             <v-toolbar-title pl-12 >
            <router-link to="/SignUpCommon">
              <h5 text class="nav_item AppHeading1 AppInguz" >SIGN UP</h5>
            </router-link>

            </v-toolbar-title>-->
            <v-spacer></v-spacer>
            <!-- </v-row> -->
          </v-toolbar-item>
        </div>

        <div v-else>
          <v-toolbar-item class="hidden-sm-and-down">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  class="nav_item AppHeading1 AppInguz tcolor"
                  style="font-size:14px;background-color:white;padding-left:10px;padding-right:10px;padding-top:5px;padding-bottom:5px; "
                >
                  <strong>MY ACCOUNT</strong>
                </span>
              </template>

              <v-list>
                <router-link to="/ProductList" v-if="usertype == 'Seller'">
                  <v-list-item>
                    <v-btn text small color="black">
                      Profile&nbsp;
                      <v-icon style="font-size:16px;">mdi-account-circle</v-icon>
                    </v-btn>
                  </v-list-item>
                </router-link>

                <router-link to="/AddProduct" v-if="usertype == 'Seller'">
                  <v-list-item>
                    <v-btn text small color="black">
                      Add Products&nbsp;
                      <v-icon style="font-size:16px;">mdi-domain</v-icon>
                    </v-btn>
                  </v-list-item>
                </router-link>
                <router-link to="/ProductList" v-if="usertype == 'Seller'">
                  <v-list-item>
                    <v-btn text small color="black">
                      View Products&nbsp;
                      <v-icon style="font-size:16px;">mdi-domain</v-icon>
                    </v-btn>
                  </v-list-item>
                </router-link>

                <router-link to="/firstpage" v-if="usertype == 'Client'">
                  <v-list-item>
                    <v-btn text small color="black">
                      View Products&nbsp;
                      <v-icon style="font-size:16px;">mdi-domain</v-icon>
                    </v-btn>
                  </v-list-item>
                </router-link>
                <router-link  to="/orderlist" v-if="usertype == 'Client'">
                  <v-list-item>
                    <v-btn text small color="black">
                     Order List&nbsp;
                      <v-icon style="font-size:16px;">mdi-file-document-box</v-icon>
                    </v-btn>
                  </v-list-item>
                    </router-link>
                   <!-- <router-link  to="/wishlist" v-if="usertype == 'Client'">
                  <v-list-item>
                    <v-btn text small color="black">
                     WishList&nbsp;
                      <v-icon style="font-size:16px;">mdi-file-document-box</v-icon>
                    </v-btn>
                  </v-list-item>
                  
                </router-link> -->

                <v-list-item>
                  <v-btn text small>
                    Settings&nbsp;
                    <v-icon style="font-size:16px;">mdi-settings</v-icon>
                  </v-btn>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar-item>
          <v-toolbar-item class="nav_item hidden-sm-and-down">
            <span
              class="nav_item AppHeading1 AppInguz tcolor"
              style="font-size:14px;background-color:white;padding-left:10px;padding-right:10px;padding-top:5px;padding-bottom:5px; "
              @click="logout"
            >
              <strong>LOGOUT</strong>
            </span>
          </v-toolbar-item>
        </div>
      </v-toolbar>
    </div>

    <!--sale-->
    <!-- <div id="appNavbar" v-if=" !isLoggedIn && usertype == 'Client'  " > -->
    <div id="appNavbar">
      <v-navigation-drawer v-model="sideNav" fixed temporary>
        <v-list-item-content class="hidden-md-and-up">
          <v-list dense>
            <v-list-item v-for="item in guestNav2" :key="item.name" link>
              <v-list-item-icon>
                <v-icon style="color:white;">{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <router-link :to="item.route">
                  <v-list-item-title style="color:#1fb07c;">{{ item.name }}</v-list-item-title>
                </router-link>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-content>
      </v-navigation-drawer>
      <v-toolbar
        color="white"
        dark
        height="40px"
        elevation="0"
        v-if="!isLoggedIn"
        class="hidden-sm-and-down"
      >
        <v-app-bar-nav-icon @click.native="sideNav = !sideNav" class="hidden-md-and-up"></v-app-bar-nav-icon>
        <!-- <v-toolbar-title>
          <v-icon style="color:#ff4e00">fas fa-list</v-icon>
        </v-toolbar-title>-->
        <v-layout wrap justify-space-around>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;padding-left:20px;">CATEGORIES</span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  FASHION
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  CLOTHING
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>

          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  SUPERMARKET
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  FURNITURES
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  ELECTRONIC
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  CLOTHING
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
        </v-layout>

        <!-- <v-spacer></v-spacer> -->

        <!-- </v-row> -->
      </v-toolbar>
      <v-toolbar
        color="white"
        dark
        height="40px"
        elevation="0"
        v-if="usertype == 'Client'"
        class="hidden-sm-and-down"
      >
        <v-app-bar-nav-icon @click.native="sideNav = !sideNav" class="hidden-md-and-up"></v-app-bar-nav-icon>
        <!-- <v-toolbar-title>
          <v-icon style="color:#ff4e00">fas fa-list</v-icon>
        </v-toolbar-title>-->
        <v-layout wrap justify-space-around>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;padding-left:20px;">CATEGORIES</span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  FASHION
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  CLOTHING
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>

          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  SUPERMARKET
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  FURNITURES
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  ELECTRONIC
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
          <v-flex>
            <v-toolbar-title pl-12>
              <router-link to="/">
                <span class="AppHeading" style="font-size:14px;">
                  CLOTHING
                  <v-icon style="color:black;font-size:13px;">fas fa-caret-down</v-icon>
                </span>
              </router-link>
            </v-toolbar-title>
          </v-flex>
        </v-layout>

        <!-- <v-spacer></v-spacer> -->

        <!-- </v-row> -->
      </v-toolbar>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { request } from "http";
export default {
  props: ["id"],
  data() {
    return {
      menu: false,

      exp1: [],
      isLoggedIn: localStorage.getItem("isLoggedIn"),
      usertype: localStorage.getItem("usertype"),
      menu2: false,
      msg: null,

      guNav: [
        { name: "DELIVERY", route: "/", icon: "mdi-home" },

        { name: "HELP", route: "/", icon: "mdi-note-text" }
      ],
      guestNav2: [
        { name: "FASHION", route: "/", icon: "mdi-home" },

        { name: "SUPERMARKET", route: "/", icon: "mdi-note-text" },
        { name: "ELECTRONIC", route: "/", icon: "mdi-note-text" },
        { name: "CLOTHING", route: "/", icon: "mdi-note-text" }
      ],
      guestNav1: [
        { name: "FASHION", route: "/", icon: "mdi-home" },

        { name: "SUPERMARKET", route: "/", icon: "mdi-note-text" },
        { name: "ELECTRONIC", route: "/", icon: "mdi-note-text" },
        { name: "CLOTHING", route: "/", icon: "mdi-note-text" }
      ],

      sideNav: false,
      sideNav2: false
    };
  },

  mounted: function() {},

  methods: {
    // district() {
    //   this.visible = true;
    //   axios({
    //     method: "GET",
    //     url: "/loc/StateList"
    //   })
    //     .then(response => {
    //       this.exp1 = response.data.data;
    //       var temp = [];

    //       for (var i = 0; i < this.exp1.length; i++) {
    //         var ty = this.exp1[i];

    //         temp.push(ty);
    //       }
    //       this.exp1 = temp;

    //       this.visible = false;
    //     })
    //     .catch(err => {
    //       this.visible = false;
    //       console.log(err);
    //     });
    // },

    logout() {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("username");
      localStorage.removeItem("token");
      localStorage.removeItem("usertype");
      localStorage.removeItem("status");
      this.isLoggedIn = false;
      // if (window.location.pathname != "/") {
      this.$router.push("/");
      window.location.reload();
      // }
    }
  }
};
</script>

<style scoped>
.bt {
  background-color: #e5e5e5;
}
.theme--dark.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #212121;
}

.theme--dark.v-label {
  color: black;
}
.v-toolbar__title {
  font-size: 0rem !important;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media only screen and (min-width: 960px) and (max-width: 1060px) {
  .AppHeading {
    font-size: 12px !important;
    font-family: "Montserrat";
  }
}
.nav_item {
  margin-top: 5px;
  margin-right: 20px;
  /* font-family: 'Montserrat'; */
}
.AppHeading {
  color: black;
  /* font-family: 'sans-serif'; */
  font-size: 10px;
  font-weight: 500 !important;
  letter-spacing: 1px !important;
  font-family: "Montserrat";
}
.AppHeading1 {
  color: white;
  /* font-family: 'sans-serif'; */
  font-size: 14px;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  font-family: "Montserrat";
}
.AppMenu {
  color: white;
  /* font-family: 'sana-serif'; */
  font-size: 12px !important;
  font-weight: 100 !important;
  text-transform: uppercase;
}
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
.AppInguz {
  color: white;
}
.v-btn__content {
  align-items: center;
  border-radius: inherit;
  color: inherit;
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  margin: 0 auto;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  width: inherit;
}
.tcolor {
  color: #f6782a;
}
.header {
  position: fixed;
  z-index: 1;
  width: 100%;
}
</style>

